import styled from 'styled-components';
import { P, fs, radius } from '../theme/tokens';

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`;

export const RangeSelect = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  background: ${P.white};
  border: 1px solid ${P.border};
  border-radius: ${radius.pill}px;

  &:focus-within {
    border-color: ${P.navy};
  }
  svg {
    font-size: 12px;
    color: ${P.subtle};
  }
  select {
    border: none;
    outline: none;
    background: transparent;
    font-family: inherit;
    font-size: ${fs.sm}px;
    font-weight: 600;
    color: ${P.ink};
    cursor: pointer;
  }
`;
